import party, { Color } from 'party-js'
import type { Attachment } from 'svelte/attachments'

export const pulsingSparkles: Attachment<HTMLElement> = (node) => {
  let emitters: party.Emitter[] = []

  const color = new Color(48, 121, 255)

  let timeoutIds = [
    setTimeout(() => {
      emitters.push(party.sparkles(node, { count: 15, lifetime: 5 }))
      emitters.push(
        party.sparkles(node, { count: 15, color: color, lifetime: 5 }),
      )
    }, 0),
    setTimeout(() => {
      emitters.push(party.sparkles(node, { count: 15 }))
      emitters.push(party.sparkles(node, { count: 15, color: color }))
    }, 2000),
  ]
  return () => {
    timeoutIds.forEach(clearTimeout)
    emitters.forEach((e) => e.clearParticles())
    emitters = []
    timeoutIds = []
  }
}

const randomColors = [
  new Color(252, 189, 123),
  new Color(255, 171, 222),
  new Color(158, 209, 255),
  new Color(255, 142, 206),
  new Color(254, 213, 136),
  new Color(255, 194, 184),
]

export const sparkles =
  (options?: {
    color?: [number, number, number] | 'random'
  }): Attachment<HTMLElement> =>
  (node) => {
    let emitters: party.Emitter[] = []

    const color =
      options?.color === 'random'
        ? randomColors[Math.floor(Math.random() * randomColors.length)]!
        : options?.color
          ? new Color(options.color[0], options.color[1], options.color[2])
          : new Color(48, 121, 255)

    emitters.push(party.sparkles(node, { count: 20, lifetime: 0.7, color }))

    return () => {
      emitters.forEach((e) => e.clearParticles())
      emitters = []
    }
  }

export const confetti: Attachment<HTMLElement> = (node) => {
  let emitters: party.Emitter[] = [party.confetti(node, { count: 50 })]

  return () => {
    emitters.forEach((e) => e.clearParticles())
    emitters = []
  }
}
